import {sapi} from '@findhotel/sapi'

import {WEB_API_KEY} from '@vio/core/src/sapi/services'

import {sapiLogger} from './sapiLogger'

import type {
  ApiSearchParameters,
  ClientOptions,
  ProfileKey
} from '@findhotel/sapi'

export type AnchorPreheatOptions = Pick<
  ClientOptions,
  | 'anonymousId'
  | 'language'
  | 'currency'
  | 'brand'
  | 'userCountry'
  | 'deviceType'
  | 'pageSize'
  | 'variations'
  | 'forcedRegion'
>

export const fetchAnchorSearch = async (
  parameters: ApiSearchParameters,
  options: ClientOptions,
  signal?: AbortSignal
) => {
  const client = await sapi(
    process.env.NEXT_PUBLIC_SAPI_PROFILE_KEY as ProfileKey,
    options
  )
  return client.searchAnchor(parameters, {signal})
}

export const createAnchorContinuationClient = (options: ClientOptions) =>
  sapi(process.env.NEXT_PUBLIC_SAPI_PROFILE_KEY as ProfileKey, {
    ...options,
    apiKey: WEB_API_KEY,
    logger: sapiLogger
  })
